import { INote } from '@ViewModels';
import * as React from 'react';
import { createContext, useState } from 'react';

export interface IDealModalContext {
	note: INote;
	setNote: React.Dispatch<React.SetStateAction<INote>>;
	interactionNote: INote;
	setInteractionNote: React.Dispatch<React.SetStateAction<INote>>;
}

export const DealModalContext = createContext<IDealModalContext>(null);

export const DealModalProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
	const [note, setNote] = useState<INote>(null);
	const [interactionNote, setInteractionNote] = useState<INote>(null);

	return (
		<DealModalContext.Provider
			value={{
				interactionNote,
				note,
				setInteractionNote,
				setNote,
			}}
		>
			{children}
		</DealModalContext.Provider>
	);
};

export const useDealModal = () => {
	return React.useContext<IDealModalContext>(DealModalContext);
};
